import { getRequest } from "@tanstack/react-start/server";
import { createServerFn } from "@tanstack/react-start";
import { serverEnv } from "./env";
import { rendererClient } from "../lib/rendererClient";

export const getProjectFromSubdomain = createServerFn({
  method: "GET",
}).handler(
  async (): Promise<{
    organizationSlug: string;
    projectSlug: string;
  }> => {
    const req = getRequest();
    const reqUrl = new URL(req.url);
    const hostname = reqUrl.hostname;

    const res = await rendererClient.projects[":hostname"].$get({
      param: {
        hostname,
      },
    });
    if (res.ok) {
      const data = await res.json();
      return data;
    }

    const [, domain, subdomain, project] = hostname.split(".").reverse();

    if (domain === "localhost") {
      return {
        organizationSlug: serverEnv.FALLBACK_ORGANIZATION_SLUG,
        projectSlug: serverEnv.FALLBACK_PROJECT_SLUG,
      };
    } else if (!project || !subdomain) {
      return {
        organizationSlug: serverEnv.FALLBACK_ORGANIZATION_SLUG,
        projectSlug: serverEnv.FALLBACK_PROJECT_SLUG,
      };
    } else {
      if (["dev"].includes(subdomain) || ["renderer"].includes(subdomain)) {
        return {
          organizationSlug: serverEnv.FALLBACK_ORGANIZATION_SLUG,
          projectSlug: serverEnv.FALLBACK_PROJECT_SLUG,
        };
      } else {
        return {
          organizationSlug: subdomain ?? serverEnv.FALLBACK_ORGANIZATION_SLUG,
          projectSlug: project ?? serverEnv.FALLBACK_PROJECT_SLUG,
        };
      }
    }
  }
);
